/**
 * Mobile-Navigation, Header-Hide-on-Scroll, ESC zum Schließen.
 */
export function navigation() {
	const navSite = document.querySelector('.nav__site')
	const header = document.querySelector('.site__header')
	const navMenuBtn = document.querySelector('.nav__menu')

	if (!navSite || !header || !navMenuBtn) return

	const body = document.body

	function toggleMenu() {
		const isOpen = body.classList.contains('js-nav-open')
		body.classList.toggle('js-nav-open', !isOpen)
		navMenuBtn.classList.toggle('is-active', !isOpen)
	}

	function closeMenu() {
		body.classList.remove('js-nav-open')
		navMenuBtn.classList.remove('is-active')
	}

	document.querySelectorAll('.js-nav__menu').forEach((item) => {
		item.addEventListener('click', toggleMenu)
	})

	navSite.querySelectorAll('li:not(.has-children)').forEach((item) => {
		item.addEventListener('click', closeMenu)
	})

	// Header bei Scroll nach unten ausblenden
	let didScroll = false
	let lastScrollTop = 0
	const delta = 20

	header.classList.add('nav-down')

	document.addEventListener('scroll', () => {
		didScroll = true
	}, { passive: true })

	setInterval(() => {
		if (!didScroll) return
		if (!navMenuBtn.classList.contains('is-active')) {
			hasScrolled()
		}
		didScroll = false
	}, 250)

	function hasScrolled() {
		const st = window.scrollY || document.documentElement.scrollTop

		if (Math.abs(lastScrollTop - st) <= delta) return

		if (st > lastScrollTop && st > window.innerHeight / 2) {
			header.classList.remove('nav-down')
			header.classList.add('nav-up')
		} else {
			header.classList.remove('nav-up')
			header.classList.add('nav-down')
		}

		lastScrollTop = st
	}

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && body.classList.contains('js-nav-open')) {
			closeMenu()
		}
	})
}
